module.exports = __webpack_public_path__ + "img/templeptah_ua.8365c173.webp";